<div class="me-register">

    <div class="me-register--process" *ngIf="meRegisterService.step != 5 && meRegisterService.step != 7">
        <div tabindex="0" role="tab" class="me-register--process--bar" [class.active]="meRegisterService.step >= 1">
            <span class="me-register--process--bar--label">{{ 'Step' | translate }} 1</span>
        </div>
        <div tabindex="0" role="tab" class="me-register--process--bar" [class.active]="meRegisterService.step >= 3">
            <span class="me-register--process--bar--label">{{ 'Step' | translate }} 2</span>
        </div>
        <div tabindex="0" role="tab" class="me-register--process--bar" [class.active]="meRegisterService.step >= 5">
            <span class="me-register--process--bar--label">{{ 'Step' | translate }} 3</span>
        </div>
    </div>

    <div class="me-register__body">
        <div class="klenico-me__background">
            <div class="klenico-me__background__inner"></div>
        </div>

        <div *ngIf="errorMessage" class="me-register__body__content mb-2 alert alert-danger" role="alert">
            <span class="fas fa-exclamation-circle" aria-hidden="true"></span>{{ errorMessage | translate }}
        </div>

        <div class="me-register__body__content me-register__body__content--privacy" *ngIf="meRegisterService.step === 1">
            <me-register-warning-card></me-register-warning-card>
            <me-register-help-card></me-register-help-card>
            <div class="button-group-xs">
                <div class="button-group-xs__note">
                    {{ 'I credibly affirm that I will not harm myself or others at this time.' | translate}}
                </div>
                <div class="button-group-xs__button">
                    <button class="btn btn--primary" (click)="meRegisterService.step = 2;">
                        {{ 'Continue' | translate}}
                    </button>
                </div>
            </div>
        </div>

        <div class="me-register__body__content me-register__body__content__privacy-card" *ngIf="meRegisterService.step === 2">
            <me-register-registration-privacy-card></me-register-registration-privacy-card>
            <div class="button-group-xs">
                <div class="button-group-xs__button">
                    <button class="btn btn--primary mb-1" (click)="meRegisterService.step = 4;">
                        {{ 'Continue' | translate}}
                    </button>
                    <button class="btn btn--secondary" (click)="meRegisterService.step = 1;">
                        {{ 'Back' | translate}}
                    </button>
                </div>
            </div>
        </div>

        <div class="me-register__body__content me-register__body__content__register-card" *ngIf="meRegisterService.step === 4">
            <me-register-form></me-register-form>
        </div>

        <div class="container" *ngIf="meRegisterService.step === 5">
            <me-register-verification></me-register-verification>
        </div>

        <div class="me-register__body__content me-register__body__content__set-password" *ngIf="meRegisterService.step === 6">
            <me-set-password [verifyToken]="verifyToken"></me-set-password>
        </div>

        <div class="container me-register__body__content__success" *ngIf="meRegisterService.step === 7">
            <me-registration-success (toDashboard)="goToDashboard()"></me-registration-success>
            <div class="button-group-xs">
                <div class="button-group-xs__button">
                    <button class="btn btn--primary mt-1" (click)="goToDashboard()">
                        {{ 'Continue' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>